export const CONNECTION_INFO = {
  host: process.env.NODE_ENV !== 'production' ? 'https://gmcmde2022.im-fine.dev' : window.location.origin 
}
